import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from '../../shared/guards/auth.guards';
import { Groups } from '../security/model/groups.model';
import { AssetTypeListComponent } from './components/asset-type-list/asset-type-list.component';

export class AssetTypeRoutingStates {
  public static readonly LIST = {
    url: 'asset-type'
  };
}

export const AssetTypeRoutes: Routes = [
  {
    path: AssetTypeRoutingStates.LIST.url,
    data: {
      page: {
        title: 'Asset Type List'
      },
      requiresRole: [Groups.ASSET_ADMINISTRATOR]
    },
    component: AssetTypeListComponent,
    canActivate: [AuthGuard]
  }
];

@NgModule({
  exports: [RouterModule],
  imports: [RouterModule.forChild(AssetTypeRoutes)]
})
export class AssetTypeRoutingModule {}
